import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from './cn.js';

const badge = cva('inline-flex items-center rounded-pill px-2 py-0.5 text-xs font-medium', {
  variants: {
    tone: {
      neutral: 'bg-grey-100 text-grey-900 border border-grey-300',
      navy: 'bg-navy-900 text-white',
      green: 'bg-green-600/10 text-green-600 border border-green-600/30',
      amber: 'bg-gold-500/15 text-[#8a6d00] border border-gold-500/40',
      red: 'bg-red-600/10 text-red-600 border border-red-600/30',
      blue: 'bg-blue-600/10 text-blue-600 border border-blue-600/30',
    },
  },
  defaultVariants: { tone: 'neutral' },
});
export function Badge({
  className,
  tone,
  ...p
}: React.HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badge>) {
  return <span className={cn(badge({ tone }), className)} {...p} />;
}
